import React from 'react'
import { Link } from 'react-router-dom'

const RejectionAlert = ({ reason }) => {
    return (
        <>
            <div className="alert alert-danger" role="alert">
                Your profile is disapproved. Please <Link to="/customer-dashboard/profile">update</Link> your profile.
                {reason ? <p> <b>Reason:</b> {reason}</p> : ""}
            </div>
        </>
    )
}

export default RejectionAlert